import React from "react";
import "./LanguageSelect.css";

const LanguageSelect = ({ languages, value, onChange, label, className = "" }) => {
  if (!languages?.length) return null;
  return (
    <select
      className={`kz-language-select ${className}`.trim()}
      value={value || ""}
      aria-label={label || "Language"}
      title={label || "Language"}
      onChange={(event) => onChange?.(event.target.value)}
    >
      {languages.map((language) => (
        <option key={language.code} value={language.code} lang={language.code}>
          {language.name}
        </option>
      ))}
    </select>
  );
};

export default LanguageSelect;
